<template>
  <div>
    <div class="Breadcrumb u-desktopOnly">
      <ul>
        <li class="Breadcrumb__item">
          <router-link to="/">{{ $t("home") }}</router-link>
        </li>
        <li class="Breadcrumb__item">
          <span>{{ $t("privacyPolicy") }}</span>
        </li>
      </ul>
    </div>



    <div class="RichTextArea">
      <div class="language-select">
        <LanguageSelector> </LanguageSelector>
        <div style="clear:both;"></div>
      </div>
      <div v-if="this.$route.query.lang !== 'ja'">
        <h1><center>Pomvom Global Privacy Policy</center></h1>
        <p><strong>Last Updated</strong>: May 2023</p>
        <p>
          We, at Pomvom Ltd., together with our affiliated companies
          (collectively: &ldquo;<strong>we</strong>&rdquo;,
          &ldquo;<strong>us</strong>&rdquo; or
          &ldquo;<strong>our</strong>&rdquo;) put great efforts to make sure
          that we secure personal data related to you and use it properly.
        </p>
        <p>
          This policy applies when we process personal data related to you when
          -
        </p>
        <ul>
          <li>
            you use our application offered for visitors to theme parks or other
            venues owned or operated by our customers;
          </li>
          <li>
            you use our services, including at:
            <a href="http://www.pomvom.com">pomvom.com</a>, landing pages and
            our other online assets; and,
          </li>
          <li>
            you contact and interact with us on social media and through other
            online and offline channels;
          </li>
        </ul>
        <p>(Collectively: the &ldquo;<strong>Services</strong>&rdquo;).</p>
        <p>
          The term &ldquo;<strong>personal data</strong>&rdquo; refers to
          information that identifies an individual or relates to an
          identifiable individual. For example, personal data is your name,
          email address, telephone number, and other contact details which you
          submit to us.
        </p>
        <p>
          The summary of this policy will give you a quick and clear view of our
          practices. Please take the time to read our full policy. If you do not
          agree to this policy, please do not access, or otherwise use the
          Services.
        </p>
        <h1><center>A Summary of this Policy</center></h1>
        <table width="99%">
          <tbody>
            <tr>
              <td width="22%">
                <p>
                  <strong>Personal Data We Receive, Collect, and Store</strong>
                </p>
              </td>
              <td width="74%">
                <p>
                  We receive, collect, and store information you enter, upload,
                  or provide on the Services.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>What Do We Do with Personal Data?</strong></p>
              </td>
              <td width="74%">
                <p>
                  We maintain the Services, make them better and continue
                  developing them, and protect us and the Services from misuse
                  and law violations.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_use')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>With Whom Do We Share Personal Data?</strong></p>
              </td>
              <td width="74%">
                <p>
                  We use service providers, for example, to send email messages
                  and to store data. We share data with our customers who own
                  the theme park that you visit. We will transfer information
                  when we change our corporate structure, and we will share the
                  information with our affiliate entities.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_sharing')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p>
                  <strong>Disclosure of Personal Data to Authorities</strong>
                </p>
              </td>
              <td width="74%">
                <p>
                  We will obey orders and other lawful requirements by
                  authorities to disclose information.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_authorities')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Aggregated and Analytical Information</strong></p>
              </td>
              <td width="74%">
                <p>
                  Aggregated data is not identifiable. We use it for legitimate
                  business purposes and for standard analytical tools.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('analytical_information')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Your Choice</strong></p>
              </td>
              <td width="74%">
                <p>
                  You can opt out of our mailing lists and terminate your use of
                  the Services. You can also request to exercise your privacy
                  rights under applicable law.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('your_choice')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Your EU Data Subject Rights</strong></p>
              </td>
              <td width="74%">
                <p>
                  If we process personal data related to you when you are in the
                  EU, further terms apply to our processing in relation to your
                  rights as a data subject under EU data protection laws.
                  <a href="javascript:void(0)" @click="scrollToRef('eu_data')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Specific Provisions for U.S. Residents</strong></p>
              </td>
              <td width="74%">
                <p>
                  If you reside in the United States (U.S.), further terms apply
                  to our processing in relation to your rights as a data subject
                  under U.S. state privacy laws.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('us_residents')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p>
                  <strong
                    >Specific Provisions under Japanese Data Protection
                    Laws</strong
                  >
                </p>
              </td>
              <td width="74%">
                <p>
                  If Japanese data protection laws apply to the processing of
                  personal data related to you by us, further terms apply to our
                  processing activities.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('japanese_data')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Personal Data Retention</strong></p>
              </td>
              <td width="74%">
                <p>
                  We retain personal data to maintain the Services, and for
                  legitimate and lawful purposes, as further explained in the
                  data retention section of this policy.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_retention')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Transfer of Data Outside Your Territory</strong></p>
              </td>
              <td width="74%">
                <p>
                  We keep personal data related to you in Israel, Japan, the
                  United States and in the EU, and will store them at additional
                  sites, at our discretion. Our service providers provide us
                  adequate security and confidentiality commitments.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('data_transfer')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Information Security</strong></p>
              </td>
              <td width="74%">
                <p>
                  We implement systems, applications, and procedures to secure
                  personal data related to you, to minimize the risks of theft,
                  damage, loss of information, or unauthorized access or use of
                  information.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('information_security')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Updates to this Privacy Policy</strong></p>
              </td>
              <td width="74%">
                <p>
                  We will update our policy from time to time after giving
                  proper notice.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('privacy_updates')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>Contact Us</strong></p>
              </td>
              <td width="74%">
                <p>
                  Please contact us at:
                  <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a> for
                  further information.
                  <a
                    href="javascript:void(0)"
                    @click="scrollToRef('contact_us')"
                    >Read More</a
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <h1 ref="personal_data">
          Personal Data We Receive, Collect, and Store
        </h1>
        <p>
          We receive, collect, and store any information you enter on the
          Services or give us in any other way.
        </p>
        <p>
          When you visit our venues, use our applications or Services, or
          contact us via the Services, we receive information you provide us.
          Examples are as follows:
        </p>
        <ul>
          <li>
            If you are a venue visitor, personal data related to you such as
            your image in photos we take at our venues, your geo-location and
            time data, and your phone number and email address. In addition, if
            you are a guardian of a minor who visits our venue and wishes to use
            the Services, your digital profile - which is generated upon account
            creation.
          </li>
          <li>
            If you are an individual who is part of our customers&rsquo;
            personnel (for example, an amusement park team member), personal
            data related to you such as your name, email address, job title,
            work location and phone number; as well as related logs of email
            exchanges or phone records, including transcriptions of
            conversations. For more information about this type of data subject,
            please read our sub-section titled &ldquo;Sales, Finance, and
            Business Operations&rdquo; below.
          </li>
          <li>
            If you use our applications in connection with the Services, we
            collect similar types of information similar to what we collect when
            you visit our venue, along with Account ID which we automatically
            generate once you have set up your account through our applications,
            information related to purchases made as part of the Services, and
            information that you provide us with over the phone or via email.
          </li>
          <li>
            When you contact us via the &ldquo;Contact Us&rdquo; link on our
            website, we collect any information you choose to provide us.
          </li>
        </ul>
        <p><strong>Marketing and Business Development</strong></p>
        <ul>
          <li>
            Information about your use of the Services and our business
            partners, including how you use the Services to help us improve
            them. Examples of such information we collect and analyze include
            the Internet Protocol (IP) address used to connect your device to
            the Internet; login; email address; password; access device and
            connection information such as browser type, version, and time zone
            setting, browser plug-in types and versions, operating system, and
            platform.
          </li>
          <li>
            Information about whether you want to receive marketing
            communications from us and what your communication preferences are.
          </li>
          <li>
            Information on how you interact with any of our emails or other
            communications, including if you have opened and engaged with such
            communications.
          </li>
          <li>
            Information we get from third parties, including our business
            partners, service providers, and publicly available information.
          </li>
        </ul>
        <p><strong>Sales, Finance, and Business Operations</strong></p>
        <ul>
          <li>
            We provide services to customers, some of them are corporations. If
            you are an employee or representative of this type of customers who
            is involved in some aspect in the relationship we have with these
            customers, we will collect information about you, such as your name,
            address, email address, job title, and telephone number so we can
            deliver the Services, provide proposals during a sales cycle and
            negotiate agreements, manage customer accounts and process and
            fulfil orders.
          </li>
          <li>
            Information about training or the services we provide to you or to
            our customers.
          </li>
          <li>
            Information we collect as part of partner on-boarding, including
            information we obtain from third parties to complete on-boarding
            compliance checks.
          </li>
          <li>
            Information we collect to deliver support to our customers,
            including ticketing information and details of the support request.
          </li>
          <li>Information we obtain from you to improve the Services.</li>
          <li>
            Information captured by our cameras if you visit any of our
            premises, visitor logs and other information we collect to ensure
            our premises remain safe and secure.
          </li>
          <li>
            We can record calls, correspondence and other communication
            channels, including screen capture, for compliance, quality,
            training and other purposes.
          </li>
          <li>
            We can video record or screen capture training seminars,
            presentations, webinars for compliance, quality, training and other
            purposes.
          </li>
          <li>
            Where we demonstrate the Services and solutions to you, we can
            collect personal data related to you as part of a trial or test.
          </li>
        </ul>
        <p><strong>Personal Data on behalf of Others</strong></p>
        <p>
          If you give us personal data about someone else through use of the
          Services, you must do so only with that person&rsquo;s express
          authorization. You must inform them how we collect, use, disclose, and
          retain personal data related to them according to this policy before
          you provide us with such personal data.
        </p>
        <p><strong>Minors</strong></p>
        <p>
          To use the Services, you must be over the age of minority. With the
          exception of photos which are taken in public spaces which can include
          images of minors, we do not knowingly collect personal data from
          minors.
        </p>
        <p>
          In relation to minors, we require a guardian's consent for the
          generation of a digital profile template and data matching. In order
          for a minor to use the Service, a guardian must hold a valid account
          with us. Minors can send a request to their guardian via our
          applications. Our applications will provide the guardian with an SMS
          request for authentication.
        </p>
        <p>
          Of note, minors can still collect their images via QR code cards from
          our representatives. However, guardian authorization will be required
          to purchase and unlock these images.
        </p>
        <p>
          We reserve the right to request proof of age, via a recognized
          identification method, at any stage so that we can verify that minors
          are not using the Services without appropriate consent. In the event
          that it comes to our knowledge that a minor is using the Services, we
          will prohibit and block the individual from accessing the Services
          until the individual&rsquo;s guardian consents to the use of the
          Services.
        </p>
        <p><strong>Cookies</strong></p>
        <p>
          Like many websites, we also use &lsquo;cookies&rsquo; and we obtain
          information when your browser accesses our website. For further
          information on cookies please see our
          <router-link to="/cookie-policy">Cookies and Similar Tracking Technologies Policy</router-link>.
        </p>
        <h1 ref="personal_data_use">What Do We Do with Personal Data?</h1>
        <p>We use personal data related to you for the following purposes:</p>
        <ul>
          <li>To provide you with the Services.</li>
          <li>
            To provide you with notifications related to your use of the
            Services and to send you marketing materials, via electronic
            newsletters, social media notifications or promotional emails.
          </li>
          <li>To solicit your feedback and provide support.</li>
          <li>
            To maintain the Services and to continue developing and making them
            better.
          </li>
        </ul>
        <p>
          We obey the law and expect you to do the same. If necessary, we will
          use personal data related to you to enforce our terms, policies, and
          legal agreements, to comply with court orders and warrants, and assist
          law enforcement agencies, to collect debts, prevent fraud,
          misappropriation, infringements, identity thefts and any other misuse
          of the Services, and to take any action in any legal dispute and
          proceeding.
        </p>
        <p>
          We commit to processing personal data related to you solely for the
          purposes described in this policy.
        </p>
        <h1 ref="personal_data_sharing">
          With Whom Do We Share Personal Data?
        </h1>
        <p>We do not sell, rent, or lease personal data related to you.</p>
        <p>
          We share personal data related to you with certain employees, as well
          as external consultants, within our corporate group, and with our
          affiliates, who are all governed by this policy. In addition, we also
          share personal data related to you with our business partners.
        </p>
        <p>
          We share personal data related to you with our vendors worldwide and
          with third-party service providers which process personal data related
          to you on our behalf, for example:
        </p>
        <ul>
          <li>
            <strong>Marketing and Business Development</strong>. To deliver our
            marketing and business development campaigns we will share
            information with digital marketing providers, social media and
            advertising companies, market research partners, potential customers
            and venues, event organizers and registration providers, and other
            trusted vendors who assist in the performance of our marketing
            campaigns.
          </li>
          <li>
            <strong
              >Sales, Finance, Business Operations and Delivering
              Service</strong
            >. We use (a) third-party sales tools to track pipeline activity and
            order information, (b) finance and invoicing tools to assist in
            managing orders, customer billing and fulfillment, (c) legal and
            compliance tools to assist in our contracting and compliance
            activities, (d) consultants, contractors and other specialists to
            provide professional services, and (e) other vendors which support
            our business operations.
          </li>
        </ul>
        <p>
          Such vendors and service providers are contractually bound to keep
          personal data related to you confidential and appropriately secure.
        </p>
        <p>
          When you visit a theme park or other venue owned or operated by one of
          our customers, and you interact with our application, we will share
          personal data with our customer, including your name, contact details
          and associated information. The customers may use the personal data
          for their own independent purposes. Please review our customers&rsquo;
          privacy notices for further information about their personal data
          practices.
        </p>
        <p>
          A merger, acquisition or any other structural change will require us
          to transfer personal data related to you to another entity, as part of
          the structural change, provided that the receiving entity will comply
          with this policy.
        </p>
        <p>
          We will share personal data related to you only subject to the terms
          of this policy, or subject to your prior consent.
        </p>
        <h1 ref="personal_data_authorities">
          Disclosure of Personal Data to Authorities
        </h1>
        <p>
          We will need to disclose personal data related to you, as we believe
          to be necessary or appropriate: (a) under applicable law, including
          laws outside your country of residence; (b) to comply with legal
          process; (c) to respond to requests from public and government
          authorities, including public and government authorities outside your
          country of residence; (d) to enforce our terms and conditions; (e) to
          protect our operations or those of any of our Affiliates; (f) to
          protect our rights, privacy, safety, interests or property, and/or
          that of our Affiliates, you or others; (g) if we are involved in any
          discussions related to the sale of all or part of our business; and,
          (h) to allow us to pursue available remedies or limit the damages that
          we can sustain.
        </p>
        <h1 ref="analytical_information">
          Aggregated and Analytical Information
        </h1>
        <p>
          We use standard analytics tools. The privacy practices of these tools
          are subject to their own privacy policies, and they use their own
          cookies to provide their service (for further information about
          cookies, please see our
          <u>Cookies and Similar Tracking Technologies Policy</u>).
        </p>
        <p>
          We use the standard analytics tools of Google Analytics and Mixpanel,
          and we will use additional or other analytics tools, from time to
          time, to learn about how you and other visitors use the Services, in
          support of the Services-related activities and operations.
        </p>
        <p>
          The privacy practices of these tools are subject to their own privacy
          policies. See Google Analytics Privacy Policy at:
          <a href="https://policies.google.com/privacy?hl=en-US"
            >Privacy Policy &ndash; Privacy &amp; Terms &ndash; Google</a
          >.. See Mixpanel Privacy Statement at:
          <a href="https://mixpanel.com/legal/privacy-policy"
            >https://mixpanel.com/legal/privacy-policy</a
          >..
        </p>
        <p>
          We use anonymous, statistical, or aggregated information and will
          share it with our affiliates for legitimate business purposes. It has
          no effect on your privacy, because there is no reasonable way to
          extract data from the aggregated information that we or others can
          associate specifically to you.
        </p>
        <h1 ref="your_choice">Your Choice</h1>
        <p>
          We will give you choices about the ways we use and share personal data
          related to you, and we will respect the choices you make.
        </p>
        <p>
          We will send newsletters or promotional communications to our users.
          To unsubscribe to these communications, you will be required to click
          an &ldquo;Unsubscribe&rdquo; link in these emails and confirm the
          email address for which you would like to unsubscribe.
        </p>
        <p>
          We collect and receive personal data related to you that we need for
          the purposes described in this policy. You can stop using the Service
          at any time, thereafter we will stop collecting personal data related
          to you. However, we will store and continue to use or make available
          certain personal data related to you as detailed above.
        </p>
        <p>
          You can request that your account with us be terminated, and that
          personal data related to you be deleted by contacting us. Any
          termination of your account will involve deletion of your account
          information from our live databases and all the information and data
          stored for the account in the service. When we process personal data
          related to an individual who is our customer&rsquo;s customer, we
          handle the deletion request in collaboration and discussions with our
          customer.
        </p>
        <p>
          You can request a copy of the personal data related to you that we
          store about you by contacting us.
        </p>
        <p>
          When we delete personal data related to you that we have collected
          from or about you, it will be deleted from our active databases, but
          we will keep a reasonable number of copies in our archives. Although
          we will deactivate your account, we will continue to retain the
          personal data related to you for legitimate business purposes as set
          forth above.
        </p>
        <p>
          We understand that some individuals can not wish for us to process
          personal data related to them in any form. Due to the automated nature
          of our photography systems, it is not possible for us to offer to not
          capture the likeness of the individual. In these circumstances, where
          an image has been captured but you do not wish for us to retain your
          photograph, you can speak to any member of our staff, and we will
          remove your images from our system. You can still purchase a physical
          print prior to enacting this feature. Once an image is removed, the
          deletion is permanent and the image cannot be recovered, even by us.
        </p>
        <p>
          Post capture, your image will be uploaded to our cloud platform where
          the initial stages of processing will be applied, which include
          compositing and image adjustment. No further processing will occur
          until you engage with the Services. Your images will be deleted
          automatically after up to 90 days.
        </p>
        <p>
          If you wish to exercise any of your rights in relation to personal
          data related to you, including exercising your choices or opt out
          rights, please send us an email to:
          <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>.
        </p>
        <h1 ref="eu_data">Your EU Data Subject Rights</h1>
        <p>
          <strong
            >If EU data protection laws apply to the processing of the personal
            data related to you by us, then the following terms apply</strong
          >:
        </p>
        <p>
          Where we process personal data related to you when you visit or use
          the Services, our processing activities are based on the following
          lawful grounds:
        </p>
        <ul>
          <li>
            All processing activities of personal data related to you which are
            not based on the lawful grounds indicated below, are based on your
            consent.
          </li>
          <li>
            We will process personal data related to you to comply with a legal
            obligation and to protect your and others' vital interests.
          </li>
          <li>
            We will further rely on our legitimate interests, which we believe
            are not overridden by your fundamental rights and freedoms, for the
            following purposes:
            <ul>
              <li>
                Communications with you in the following circumstances:
                <ul>
                  <li>
                    Where you contact us through the Services and other digital
                    assets:
                  </li>
                  <li>After you sign up for our marketing or newsletter.</li>
                  <li>
                    After you, on behalf of your company, sign up for any of the
                    Services.
                  </li>
                </ul>
              </li>
              <li>Cyber security.</li>
              <li>Support, customer relations, service operations.</li>
              <li>Fraud detection and misuse of the Services.</li>
            </ul>
          </li>
        </ul>
        <p>
          In addition to your rights under other sections in this policy, you
          have the following rights:
        </p>
        <ul>
          <li>
            At any time, contact us if you want to withdraw your consent to the
            processing of personal data related to you. Exercising this right
            will not affect the lawfulness of processing based on consent before
            its withdrawal.
          </li>
          <li>
            Request to delete or restrict access to personal data related to
            you. We will review your request and use our judgment, pursuant to
            the provisions of applicable law, to reach a decision about your
            request.
          </li>
          <li>
            If you exercise one (or more) of the above-mentioned rights, in
            accordance with the provisions of applicable law, you can request to
            be informed that third parties that hold personal data related to
            you, in accordance with this policy, will act accordingly.
          </li>
          <li>
            You can ask to transfer personal data related to you in accordance
            with your right to data portability.
          </li>
          <li>
            You can object to the processing of personal data related to you for
            direct marketing purposes. Additional information about this right
            is available under the &lsquo;Your Choice&rsquo; section in this
            policy.
          </li>
          <li>
            You have the right not to be subject to a decision based solely on
            automated processing, including profiling, which produces legal
            effects concerning you or similarly significantly affecting you.
          </li>
          <li>
            You have a right to lodge a complaint with a data protection
            supervisory authority of your habitual residence, place of work or
            of an alleged infringement of the GDPR.
          </li>
        </ul>
        <p>
          A summary and further details about your rights under EU data
          protection laws, is available on the EU Commission's website available
          at:
          <a
            href="https://ec.europa.eu/info/law/law-topic/data-protection/reform/rights-citizens_en"
            >Rights for citizens | European Commission (europa.eu)</a
          >.
        </p>
        <p>
          Note that when you send us a request to exercise your rights, we will
          need to reasonably authenticate your identity and location. We will
          ask you to provide us with credentials to make sure that you are who
          you claim to be and will further ask you some questions to understand
          the nature and scope of your request.
        </p>
        <p>
          If we need to delete personal data related to you following your
          request, it will take some time until we completely delete residual
          copies of personal data related to you from our active servers and
          from our backup systems.
        </p>
        <p>
          If you have any concerns about the way we process personal data
          related to you, you are welcome to contact our Data Protection Officer
          at: <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>. We
          will look into your inquiry and make good-faith efforts to respond
          promptly.
        </p>
        <p>
          <strong
            >Data Protection Officer(s) and EU and UK Representatives</strong
          >
        </p>
        <p>
          Our Data Protection Officer can be reached at:
          <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>.
        </p>
        <p>
          Our EU representative is located at C/ Federico Mompou 5, Parque
          Empresarial Las Tablas, Edificio 1, Planta 3, 28050, Madrid, Spain;
          email address:
          <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>.
        </p>
        <p>
          Our UK representative is located at 9 Victoria Way, Pride Park, Derby,
          United Kingdom DE24 8AN; email address:
          <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>.
        </p>
        <h1 ref="us_residents">Specific Provisions for U.S. Residents</h1>
        <p>
          This section applies solely to all Services visitors, users and others
          who reside within the United States (U.S.). We have adopted this
          section to comply with U.S. state privacy laws, and any terms defined
          under U.S. state privacy laws will have the same meaning when used in
          this section. This chapter supersedes any contradicting provisions
          under the other sections of this policy.
        </p>
        <p>
          We have collected the personal data related to you which is described
          above under the section &ldquo;Personal Data We Receive, Collect, and
          Store&rdquo; of this policy. Such Information consists of the
          following categories:
        </p>
        <ul>
          <li>
            Identifiers and Personal data categories listed in the applicable
            laws, such as the California Customer Records statute (Cal. Civ.
            Code &sect; 1798.80(e)).
          </li>
          <li>
            Internet or other electronic network activity information,
            including, but not limited to, browsing history, search history, and
            information regarding your interaction with the Services.
          </li>
          <li>
            Commercial information, including products or services purchased,
            obtained, or considered, or other purchasing or consuming histories
            or tendencies.
          </li>
          <li>Geolocation data, namely your physical location or movements.</li>
          <li>Inferences drawn from any of the above-mentioned information.</li>
        </ul>
        <p>
          We obtain the categories of personal data related to you listed above
          from the following categories of sources:
        </p>
        <ul>
          <li>
            Directly and indirectly from you and your activity on the Services.
          </li>
          <li>Third parties such as reliable service providers.</li>
        </ul>
        <p>
          We use the personal data related to you that we collect or receive for
          the purposes mentioned under this Policy.
        </p>
        <p>
          We disclose personal data related to you to third parties for business
          purposes as described above under the section titled &ldquo;With Whom
          Do We Share Personal Data?&rdquo;.
        </p>
        <p><strong>Selling and Sharing Personal data</strong></p>
        <p>
          We do not sell or share personal data. However, we engage third
          parties to provide us with services such as analytics, marketing
          automation and user experience and allow them to collect personal data
          on the Services.
        </p>
        <p>
          We do not knowingly sell or share the personal data of consumers who
          are under 16 years of age.
        </p>
        <p>
          The categories of personal data collected by these third parties in
          the preceding 12 months include identifiers, online activities and
          inferences drawn from such activities.
        </p>
        <p>
          These third parties do not pay us for collecting such information, but
          the right granted to them to collect personal data can be considered
          as disclosure for the purpose of sale or sharing for cross-context
          behavioral advertising. At any time, you can opt out of the collection
          of personal data by our service Providers by contacting us.
        </p>
        <p><strong>Your rights as a U.S. Resident</strong></p>
        <p>
          In addition to your rights under other sections under this policy, if
          you are a resident of California or any other applicable US State, you
          are entitled also to the following specific rights under the CPRA or
          other applicable US state consumer privacy acts, regarding personal
          data related to you:
        </p>
        <ul>
          <li>
            Access to specific personal data and data portability rights - you
            have the right to request that we disclose certain information to
            you about our collection and use of personal data related to you
            over the past 12 months. Upon verification of your request, we will
            disclose to you:
            <ul>
              <li>The categories of personal data we collected about you;</li>
              <li>
                The categories of sources for the personal data we collected
                about you;
              </li>
              <li>
                Our business or commercial purpose for collecting that personal
                data;
              </li>
              <li>
                The categories of personal data that we disclosed for a business
                purpose, and the categories of third parties with whom we
                disclosed that particular category of personal data;
              </li>
              <li>
                The specific pieces of personal data that we collected about
                you;
              </li>
              <li>
                If we disclose personal data related to you for a business
                purpose, we will provide you with a list which will identify the
                personal data categories that each category of recipient
                obtained.
              </li>
            </ul>
          </li>
          <li>
            Deletion rights - you have the right to request that we delete any
            personal data related to you. Upon confirmation of your request, we
            will delete personal data related to you from our records, unless an
            exception applies.
          </li>
          <li>
            Non-discrimination &ndash; you also have a right not to be
            discriminated against for exercising your rights under the CPRA.
          </li>
        </ul>
        <p><strong>Exercising Your Rights</strong></p>
        <p>
          To exercise the access, data portability, and deletion rights
          described above, please submit your request to us by sending an email
          message to:
          <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>. Only you
          or a person authorized to act on your behalf can make a request
          related to personal data related to you. A request for access can be
          made by you only twice within a 12-month period.
        </p>
        <p>
          The verifiable consumer request must provide sufficient information
          that allows us to reasonably verify you are the person about whom we
          collected personal data or an authorized representative and describe
          your request with sufficient detail that allows us to properly
          understand, evaluate, and respond to it.
        </p>
        <p>
          We cannot respond to your request or provide you with the requested
          Personal data if we cannot verify your identity or authority to make
          the request and confirm the personal data related to you. We will only
          use the personal data provided in your request to verify your identity
          or authority to make the request.
        </p>
        <p>
          We will do our best to respond to your request within 30 days of its
          receipt. If we require more time (up to an additional 30 days), we
          will inform you of the reason and extension period in writing. If you
          do not have an account with us, we will deliver our written response
          by mail or electronically, at your option.
        </p>
        <p>
          Any disclosures we provide will only cover the 12-month period
          preceding receipt of your request. The response we provide will also
          explain the reasons we cannot comply with a request, if applicable.
        </p>
        <p>
          We do not charge a fee to process or respond to your request unless it
          is excessive, repetitive, or manifestly unfounded. If we determine
          that the request warrants a fee, we will inform you of the reasons for
          such a decision and provide you with a cost estimate before completing
          your request.
        </p>
        <p>
          We will not require that you create an account in order to exercise
          your rights under this policy and we will not increase the cost, or
          decrease the availability, of the Services based solely on the fact
          that you have chosen to exercise one of your rights under U.S. privacy
          laws.
        </p>
        <p>
          After receiving our reply, you can appeal against our decision by
          contacting us. We will review your appeal and provide you with our
          answer and our explanation of the reasons for our decision(s) within
          60 days of receiving it. We will also provide you with a link (to the
          extent available) where you can submit a complaint with the relevant
          Attorney General.
        </p>
        <h1 ref="japanese_data">
          Specific Provisions under Japanese Data Protection Laws
        </h1>
        <p>
          We have adopted this section to comply with Japanese privacy laws,
          such as the Act on the Protection of Personal Information (the
          &ldquo;<strong>APPI</strong>&rdquo;), where applicable. This chapter
          applies only when the APPI applies to our processing activities of
          personal data related to you and supersedes any contradicting
          provisions under the other sections of this policy.
        </p>
        <p>
          Information about the types of personal data related to you, the
          purposes we process such personal data, and the third parties with
          whom we share it, is detailed in this policy.
        </p>
        <p>
          In addition to your rights under other sections within this policy,
          you are entitled to the following specific rights under the APPI or
          other applicable Japanese privacy acts:
        </p>
        <p>
          * You have the right to&nbsp;request a deletion of personal data
          related to you, or cessation of processing of personal data related to
          you, to the extent such processing is out of scope necessary to
          provide you with our Services, protect and improve them, and comply
          with applicable law.&nbsp;
        </p>
        <p>
          * You have the right to request access to personal data related to
          you, a summary of our data security measures in relation to the same,
          and a list of third parties that have access to personal data related
          to you including their territories.&nbsp;
        </p>
        <p>
          To exercise your privacy rights, please submit your request to us by
          sending an email message to:&nbsp;<a href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >. Only you or a person authorized to act on your behalf can make a
          request related to personal data related to you.&nbsp;You must provide
          sufficient information that allows us to reasonably verify you are the
          person about whom we collected personal data or an authorized
          representative and describe your request with sufficient detail that
          allows us to properly understand, evaluate, and respond to it.
        </p>
        <p>
          The entity in charge of managing the use of personal data is:&nbsp;<u
            >Pomvom Ltd.</u
          >, and the person in charge of managing the use of personal data
          is:&nbsp;<u>Pomvom's DPO</u>, available at:&nbsp;<u
            >9 Victoria Way, Pride Park, Derby, United Kingdom DE24 8AN</u
          >; email address:&nbsp;<a href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >.
        </p>
        <h1 ref="personal_data_retention">Personal Data Retention</h1>
        <p>
          We retain different types of personal data related to you for
          different periods, depending on the purposes for processing the
          information, our legitimate business purposes, and pursuant to legal
          requirements under applicable law.
        </p>
        <p>
          We will maintain your contact details, to help us stay in contact with
          you. At any time, you can contact our Data Protection Officer
          at:&nbsp;<a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>
          and request to delete your contact details. Note that we will keep
          your details without using them if necessary, and for the necessary
          period of time, for legal requirements and proceedings.
        </p>
        <p>
          We will retain personal data related to you after you have terminated
          your use of the Services, if retention is reasonably necessary to
          resolve disputes between our users, to prevent fraud and abuse, or to
          enforce this policy and our
          <a href="https://www.pomvom.com/terms">Terms and Conditions</a>. We
          will keep aggregated non-identifiable information without limitation,
          and to the extent reasonable we will delete or de-identify potentially
          identifiable information, when we no longer need to process the
          information.
        </p>
        <p>
          In any case, we will keep information about you for as long as you use
          the Services, unless applicable law requires us to delete it, or if we
          decide to remove it at our discretion, according to the terms of this
          policy and our
          <a href="https://www.pomvom.com/terms">Terms and Conditions</a>.
        </p>
        <h1 ref="data_transfer">Transfer of Data Outside Your Territory</h1>
        <p>
          We store and process information, including personal data, either
          directly or using third parties, such as data hosting service
          providers, in Israel, Japan, the United States and in the EU. The laws
          of the territories where your data will be stored and processed can
          differ from the laws of the jurisdiction in which you live.
        </p>
        <p>
          If you are a resident in a jurisdiction where transfer of personal
          data related to you to another jurisdiction requires your consent,
          then you provide us with your express and unambiguous consent to such
          transfer.
        </p>
        <p>
          If you are located in the European Economic Area (EEA), note that we
          will transfer personal data related to you to other jurisdictions,
          which are not deemed to provide an adequate level of data protection.
          In such case, we will use appropriate safeguards, in particular, by
          way of entering into the European Union (EU) Standard Contractual
          Clauses as amended from time to time with the relevant recipients, or
          by adhering to equivalent data transfer regulations to protect the
          security and confidentiality of such personal data. You can obtain a
          copy of the suitable safeguards that we use when transferring personal
          data as described above or receive further information about data
          transfer by contacting us at:
          <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>.
        </p>
        <p>
          We make sure that our third-party service providers, provide us with
          adequate confidentiality and security commitments and we will take all
          steps reasonably necessary to ensure that personal data related to you
          is treated securely and in accordance with this policy.
        </p>
        <h1 ref="information_security">Information Security</h1>
        <p>
          We are committed to ensuring the security of personal data. We and our
          hosting services implement systems, applications, and procedures to
          secure personal data related to you, to minimize the risks of theft,
          damage, loss of information, or unauthorized access or use of
          information. These measures provide sound industry standard security.
        </p>
        <p>
          However, please understand that no security system is impenetrable,
          and although we make efforts to protect your privacy, we cannot
          guarantee that the Services will be immune from any wrongdoings,
          malfunctions, unlawful interceptions or access, or other kinds of
          abuse and misuse.
        </p>
        <p>
          For more information on how the technology underlying our Service
          works and what we do to protect your privacy in accordance with
          applicable law, please review our&nbsp;<a
            href="https://pomvom.com/faq"
            >Technology and Privacy Frequently Asked Questions (FAQ)</a
          >.
        </p>
        <h1 ref="privacy_updates">Updates to this Privacy Policy</h1>
        <p>From time to time, we will update this policy.</p>
        <p>
          Where the updates have minor if any consequences, they will take
          effect 7 days after we post a notice on the Services. Where the
          updates have substantial consequences, they will be effective 30 days
          after we initially posted the notice.
        </p>
        <p>
          Until the new policy takes effect, if it materially reduces the
          protection of your privacy right under the then-existing policy you
          can choose not to accept it and terminate your use of the Services.
        </p>
        <p>
          Continuing to use the Services after the new policy takes effect means
          that you agree to the new policy.
        </p>
        <p>
          Note that if we need to adapt the policy to legal requirements, the
          new policy will become effective immediately or as required by law.
        </p>
        <h1 ref="contact_us">Contact Us</h1>
        <p>
          Please contact us at:
          <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>.
        </p>
        <p>
          We can only process requests received with sufficient information to
          enable us to process your request. If we need to request additional
          information in order to complete your request, we will do so. If you
          do not provide sufficient information initially and do not respond to
          our request for additional information, we will not be able to
          complete your request.
        </p>
        <p>
          Please note that email communications are not always secure, so please
          do not include any sensitive information in your emails to us.
        </p>
      </div>
      <!--
      <div v-if="this.$route.query.region && this.$route.query.region.toLowerCase() == 'uk'" v-html="$t('privacyPolicyUkHtml')"></div>
      <div v-if="this.$route.query.region && this.$route.query.region.toLowerCase() == 'us'" v-html="$t('privacyPolicyUsHtml')"></div>
      -->

      <div v-if="this.$route.query.lang === 'ja'">
        <h1><center>Oc Pomvomグローバルプライバシーポリシー</center></h1>
        <p>
          <strong>最終更新：</strong><strong>2023</strong><strong>年</strong
          ><strong>5</strong><strong>月</strong><strong>○</strong
          ><strong>日</strong>
        </p>
        <p>
          弊社Pomvom
          Ltd.及び関連会社（以下、総称して「<strong>私たち</strong>」、「<strong>当社</strong>」、或いは「<strong>弊社</strong>」という）は貴殿の個人データを適切に保護または利用するために日々最大限の努力を行っております。
        </p>
        <p>
          本ポリシーは以下の場合において、貴殿に関連する個人データを処理する際に適用されます。
        </p>
        <ul>
          <li>
            貴殿が当社が提供する当社顧客によって所有または運営されるテーマパークやその他の会場の訪問者向けアプリケーションを利用するとき、
          </li>
          <li>
            貴殿が<a href="http://www.pomvom.com">pomvom.com</a
            >を含むが限定だれない当社のサービス、ランディングページやその他のオンライン資産を利用するとき、そして
          </li>
          <li>
            貴殿がソーシャルメディアやその他のオンライン又はオフライン方法にて当社に連絡とき
          </li>
        </ul>
        <p>（以下、称して「<strong>サービス</strong>」という）。</p>
        <p>
          「<strong>個人データ</strong>」とは、個人を識別する情報または識別可能な個人に関連する情報のことを指す。例えば、個人データには、貴殿が当社に提供する氏名、メールアドレス、電話番号、その他の連絡先情報が含まれます。
        </p>
        <p>
          本ポリシーの要約は、当社のプラクティスを簡潔かつ分かりやすくまとめたものとなります。是非、本ポリシーの全文をお読み頂けますようお願い申し上げます。万が一、本ポリシーに同意されない場合は、サービスにアクセスしたり、それ以外の方法で利用したりしないでください。
        </p>
        <h1><center>本ポリシーの要約</center></h1>
        <table width="99%">
          <tbody>
            <tr>
              <td width="22%">
                <p><strong>私たちが受領、収集、保管する個人データ</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社は貴殿がサービスに入力、アップロードまたは提供する個人データを受領、収集、保管します。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data')"
                    >もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p>
                  <strong
                    >私たちは個人データをどのように使っていますか？</strong
                  >
                </p>
              </td>
              <td width="74%">
                <p>
                  サービスの維持、改善、そしてさらなる開発を行いながら、当社及びサービスそのものを不正使用や法令違反から守ります。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_use')"
                  >
                    もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>誰と個人データを共有していますか？</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社は、例えば、サービスプロバイダーを通じてメールを送信したり、データを保管したりしています。当社は、貴殿が訪問したテーマパークを保有する顧客にデータを共有しています。当社は、組織再編の際に情報を転送し、関連会社と情報を共有します。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_sharing')"
                    >もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>当局への個人データの開示</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社は、情報開示を求める当局からの命令やその他の法的要求に従います。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_authorities')"
                    >もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>集計情報及び分析情報</strong></p>
              </td>
              <td width="74%">
                <p>
                  集約されたデータは識別不能です。当社は、本データを正当なビジネス目的及び標準的な分析ツールに使用します。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('analytical_information')"
                    >もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>貴殿の選択</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社のメーリングリストを解除し、サービスのご利用を終了することができます。適用法に基づいてプライバシー権の行使を要求することもできます。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('your_choice')"
                    >もっと詳しく</a
                  >.
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>EU</strong><strong>データ主体の権利</strong></p>
              </td>
              <td width="74%">
                <p>
                  EUに滞在中に当社がお客様に関連する個人データを処理する場合、EUのデータ保護法に基づくデータ主体としての権利に関して、当該処理に対し、さらなる条件が適用されます。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('eu_data')"
                    >もっと詳しく</a
                  >.
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>米国向けの特定規定居住者</strong></p>
              </td>
              <td width="74%">
                <p>
                  アメリカ合衆国（米国）にお住まいの場合、米国の州プライバシー法に基づくデータ主体としての権利に関して、当該処理に対し、さらなる条件が適用されます。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('us_residents')"
                    >もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>日本のデータ保護法に基づく特定規程</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社による貴殿の個人データの処理が日本のデータ保護法の対象の場合、当該処理に対し、さらなる条件が適用されます。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('japanese_data')"
                    >もっと詳しく</a
                  >.
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>個人データ保持</strong></p>
              </td>
              <td width="74%">
                <p>
                  サービスの維持及び正当かつ合法的な目的のために、個人データを保持します。詳細は、本ポリシーのデータ保持セクションで説明されています。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('personal_data_retention')"
                    >もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>区域外のデータ転送</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社は、貴殿に関連する個人データをイスラエル、日本、米国、及びEU
                  に保管し、当社の裁量によりこれら以外の場所に保管する場合があります。当社のサービスプロバイダーは、十分なセキュリティ及び機密保持能力を有していることを表明してくれています。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('data_transfer')"
                    >もっと詳しく</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>情報セキュリティー</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社は、貴殿に関連する個人データを保護するためのシステム、アプリケーション、手順を導入し、情報の盗難、損傷、損失、または情報の不正アクセスや使用のリスクを最小限に抑えます。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('information_security')"
                    >もっと詳しく</a
                  >.
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>本プライバシーポリシーの更新</strong></p>
              </td>
              <td width="74%">
                <p>
                  当社は、適切な通知を行った後、定期的に本ポリシーを更新します。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('privacy_updates')"
                    >もっと詳しく</a
                  >.
                </p>
              </td>
            </tr>
            <tr>
              <td width="22%">
                <p><strong>お問い合わせ</strong></p>
              </td>
              <td width="74%">
                <p>
                  詳細につきましては<a href="mailto:privacy@pomvom.com"
                    >privacy@pomvom.com</a
                  >までお問い合わせください。<a
                    href="javascript:void(0)"
                    @click="scrollToRef('contact_us')"
                    >もっと詳しく</a
                  >.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <h1 ref="personal_data">私たちが受領、収集、保管する個人データ</h1>
        <p>
          当社は、貴殿がサービス上で入力した情報、またはその他の方法で当社に提供した情報を受信、収集、保存します。
        </p>
        <p>
          当社の施設を訪問したり、当社のアプリケーションやサービスを利用したり、またはサービスを通じて当社に連絡したりすると、当社は貴殿から提供された情報を受け取ります。以下は例となります。
        </p>
        <ul>
          <li>
            貴殿が当社の施設を訪問した際、当施設で撮影した写真における貴殿の画像、位置情報や時間データ、電話番号やメールアドレスなど、貴殿に関連する個人データを収集する場合があります。さらに、貴殿が当社の施設を訪問してサービスを利用したい未成年者の保護者でいらっしゃる場合、アカウント作成時に生成されるデジタルプロフィールに含まれる個人データを収集する場合があります。
          </li>
          <li>
            もし貴殿が当社の顧客の職員の一員であり（例：遊園地のスタッフなど）、貴殿に関連する個人データとして、氏名、メールアドレス、役職、勤務地、電話番号などを収集する場合があります。さらに、メールのやり取りや電話記録の関連ログ、会話の文字起こしなども対象となります。この類のデータ主体に関する詳細な情報については、下記「セールス、財務、及び事業運営」のサブセクションをお読みください。
          </li>
          <li>
            貴殿がサービスと連動して当社アプリケーションを利用する場合、当社は、貴殿が当社アプリケーション経由でアカウントを設定する際に自動的に生成されるアカウントIDとともに、当社施設を訪問した際に収集するものと同様の種類の情報を収集します。また、サービスの一環として行われた購入に関連する情報、それから電話またはメールで提供された情報も収集します。
          </li>
          <li>
            当社ウェブサイトの「お問い合わせ」リンクからお問い合わせを頂いた場合、貴殿が任意的に提供される情報を収集します。
          </li>
        </ul>
        <p><strong>マーケティング及びビジネスデベロップメント</strong></p>
        <ul>
          <li>
            貴殿のサービス利用状況と当社のビジネスパートナーに関連する情報。貴殿のサービス利用がどのようにサービスの改善に役立てているかも含まれます。当社が収集及び分析する情報の例として、デバイスをインターネットに接続するために使用されるインターネットプロトコル
            (IP)
            アドレス、ログイン名、メールアドレス、パスワード、それからブラウザの種類、バージョン、タイムゾーン設定、ブラウザのプラグインの種類とバージョン、オペレーティングシステム、プラットフォームなどといったアクセスデバイスと接続に関する情報が挙げられます。
          </li>
          <li>
            当社からのマーケティングコミュニケーションを受け取るかどうか、及び貴殿のコミュニケーションの好みに関する情報。
          </li>
          <li>
            当社のメールやその他のコミュニケーションとの関わり方に関する情報を含みます。例えば、メールを開封し、そのコミュニケーションに回答したかどうかなどの情報が含まれます。
          </li>
          <li>
            当社のビジネスパートナーやサービスプロバイダー、公開されている情報を含む、第三者から取得する情報。
          </li>
        </ul>
        <p><strong>セールス、財務、及び事業運営</strong></p>
        <ul>
          <li>
            当社、一部が法人である顧客に対してサービスを提供しています。もし貴殿がこの種の顧客の従業員または代表者であり、そして当社とこれらの顧客との関係に何らかの側面で関与している場合、サービスの提供、営業活動の一環として行う提案、契約の渉外、顧客アカウントの管理、注文の処理及び履行などを行うために、当社は貴殿の氏名、住所、メールアドレス、役職、電話番号などといった情報を収集します。
          </li>
          <li>
            当社が貴殿または当社の顧客に提供する研修またはサービスに関する情報。
          </li>
          <li>
            パートナーのオンボーディングの一環として収集する情報。これにはオンボーディング時のコンプライアンスチェックを完了するために第三者から入手する情報も含まれます。
          </li>
          <li>
            顧客をサポートするために収集する情報。これにはチケット情報やサポートリクエストの詳細が含まれます。
          </li>
          <li>サービスを改善するために貴殿から収集する情報。</li>
          <li>
            当社の施設を訪れた場合、カメラによって記録される情報、来訪者ログ、及び施設の安全とセキュリティを確保するために収集するその他の情報。
          </li>
          <li>
            当社は、コンプライアンス、品質管理、トレーニング、その他の目的のために電話、文通、スクリーンキャプチャーを含むその他のコミュニケーションチャネルを記録することがあります。
          </li>
          <li>
            当社は、コンプライアンス、品質管理、トレーニング、その他の目的のためにトレーニングセミナー、プレゼンテーション、ウェビナーなどをビデオ録画またはスクリーンキャプチャすることがあります。
          </li>
          <li>
            当社がサービス及びソリューションを貴殿にデモンストレーションする場合、トライアルまたはテストの一環として貴殿に関連する個人データを収集することがあります。
          </li>
        </ul>
        <p><strong>他者に代わっての個人データ</strong></p>
        <p>
          サービスを通じて他人の個人データを提供する場合、当該人物の明示的な同意を得る必要があります。貴殿が、かかる個人データを当社に提供する前に、本ポリシーに従って当社が当該人物に関連する個人データをどのように収集、使用、開示、保持するかを説明する必要があります。
        </p>
        <p><strong>未成年者</strong></p>
        <p>
          サービスを利用するには成人である必要があります。公共の場で撮影された未成年者の画像が含まれる可能性のある写真を除き、当社は未成年者から故意に個人データを収集しません。
        </p>
        <p>
          未成年者に関しては、デジタルプロフィールの作成やデータの照合については、保護者の同意が必要です。未成年者がサービスを利用するには、保護者が当社の有効なアカウントを保持している必要があります。未成年者は、アプリケーションを通じて保護者にリクエストを送信することができます。当社のアプリケーションは、保護者に認証のためのSMSリクエストを送信します。
        </p>
        <p>
          重要な点として、未成年者は当社の代理人からQRコードカードを通じて自分の画像を収集することができます。ただし、これらの画像を購入し、ロックを解除するには、保護者の承認が必要です。
        </p>
        <p>
          当社は、未成年者が適切な同意なしにサービスを利用していないことを確認するために、いかなる段階においても、認知された本人確認方法を介して年齢確認を要求する権利を留保します。未成年者がサービスを利用していることが判明した場合、当社は、保護者がサービスの利用に同意するまで、当該個人のサービスへのアクセスを禁止し、ブロックします。
        </p>
        <p><strong>クッキー</strong></p>
        <p>
          多くのウェブサイトと同様に、当社も「クッキー」を使用し、お使いのブラウザが当社のウェブサイトにアクセスした際に情報を取得します。クッキーの詳細については、当社の「<u>クッキー及び類似のトラッキング技術に関するポリシー</u>」をご覧ください。
        </p>
        <h1 ref="personal_data_use">
          私たちは個人データをどのように使っていますか？
        </h1>
        <p>貴殿に関する個人データを次のように使います。</p>
        <ul>
          <li>貴殿にサービスを提供するため。</li>
          <li>
            電子ニュースレター、ソーシャルメディア通知、またはプロモーションメールを通じて、サービスの使用に関連する通知やマーケティング資料を送信するため。
          </li>
          <li>貴殿からのフィードバックを求め、サポートを提供するため。</li>
          <li>サービスの維持、継続的な開発及び改善のため。</li>
        </ul>
        <p>
          当社は法律を遵守し、貴殿にも同様に法律を遵守して頂きたく存じます。必要に応じて、当社は、当社の利用規約、ポリシー、法的契約の適用、裁判所の命令や令状の遵守、警察機関との協力、債務の回収、詐欺、横領、侵害、なりすまし、その他のサービスの不正使用の防止、及び法的紛争や訴訟の対処をするために貴殿に関連する個人データを利用することがあります。
        </p>
        <p>
          当社は、本ポリシーに記載されている目的のためにのみ、貴殿に関連する個人データを処理することを約束します。
        </p>
        <h1 ref="personal_data_sharing">誰と個人データを共有していますか？</h1>
        <p>
          当社は、お客様に関する個人データを販売、レンタル、リースすることはありません。
        </p>
        <p>
          当社は、貴殿に関連する個人データを、当社グループ内の特定の従業員、外部コンサルタント、及び当社の関連会社と共有することがあります。なお、これらすべてがこのポリシーに準拠します。また当社のビジネスパートナーと貴殿に関連する個人データを共有することがあります。
        </p>
        <p>
          当社は、当社の世界中のベンダー及び当社に代わって貴殿に関連する個人データを処理する第三者のサービスプロバイダーに貴殿に関連する個人データを共有します。例えば、
        </p>
        <ul>
          <li>
            <strong>マーケティング及びビジネスデベロップメント</strong
            >当社のマーケティングおよび事業開発キャンペーンを実施するために、当社は、デジタルマーケティングプロバイダー、ソーシャルメディア及び広告会社、市場調査パートナー、潜在的な顧客及び会場、イベント主催者及び登録プロバイダー、並びに当社のマーケティングキャンペーンの実施を支援するその他の信頼できるベンダーと情報を共有します。
          </li>
          <li>
            <strong>セールス、財務、事業運営及びサービス提供</strong>当社は、(a)
            パイプラインや注文情報を管理するために第三者の販売ツール、(b)
            注文管理、顧客請求と注文履行のために財務及び請求ツール、(c)
            当社の契約とコンプライアンス関連業務のために法律およびコンプライアンスツール、(d)
            専門サービスを提供するコンサルタント、請負業者およびその他の専門家、並びに
            (e) 当社の事業運営をサポートするその他のベンダー、を利用します。
          </li>
        </ul>
        <p>
          これらのベンダーおよびサービスプロバイダーは、貴殿に関連する個人データを機密に保ち、適切かつ安全に管理する契約上の義務を負っています。
        </p>
        <p>
          貴殿が、当社の顧客が所有または運営するテーマパークまたはその他の会場を訪問し、当社のアプリケーションを操作する際、当社は貴殿の氏名、連絡先の詳細、関連情報などの個人データを顧客と共有します。当社の顧客は、独自の目的のために当該個人データを使用することができます。当社の顧客の個人データの取扱いに関する詳細な情報については、顧客のプライバシー通知をご確認ください。
        </p>
        <p>
          合併、買収、またはその他の組織再編の際、当組織再編の一環として受け取り側の事業体が本ポリシーに従うことを条件として、貴殿に関連する個人データを別の事業体に転送する必要が生じるがことがあります。
        </p>
        <p>
          当社は、貴殿に関連する個人データを、本ポリシーの条件に従った場合、または貴殿の事前同意がある場合にのみ共有します。
        </p>
        <h1 ref="personal_data_authorities">当局への個人データの開示</h1>
        <p>
          当社は、必要または適切であると考えられた場合、次のようなシナリオにおいて貴殿に関連する個人データを開示することがあります：
          (a) 貴殿の居住国以外の法律を含む適用法に基づいて開示が必要な場合、(b)
          法的手続きに従うため、(c)
          貴殿の居住国以外の公的機関及び政府機関を含む公的機関及び政府機関からの要請に対応するため、(d)
          当社の利用規約を適用するため、(e)
          当社または当社の関連会社の事業を保護するため、(f)
          当社の権利、プライバシー、安全、利益、財産、及びまたは当社の関連会社、貴殿、その他の当事者の同権利、利益、財産等を保護するため、(g)
          当社が当社の事業の全部または一部の売却に関連する渉外を行っている場合、及び（h）当社が利用可能な救済策を講じたり、当社が被る損害を制限したりするため。
        </p>
        <h1 ref="analytical_information">集計情報及び分析情報</h1>
        <p>
          当社は標準的な分析ツールを利用します。これらのツールのプライバシーの取り扱いは、それぞれの独自のプライバシーポリシーに準拠します。また、独自のクッキーを使用してサービスを提供します（クッキーに関する詳細な情報については、当社の「<u>クッキー及び類似のトラッキング技術に関するポリシー</u>」をご覧ください）。
        </p>
        <p>
          当社は、Google
          Analytics及びMixpanelの標準分析ツールを使用します。また、サービス関連のアクティビティ及び運用をサポートするために、貴殿並びに他の訪問者がどのようにサービスを利用しているかを把握すべく、その都度これらに加え、その他の分析ツールを利用することがあります。
        </p>
        <p>
          これらのツールのプライバシーの取り扱いは、それぞれの独自のプライバシーポリシーに準拠します。Google
          Analyticsのプライバシーポリシーは以下リンクからご確認ください。<a
            href="https://policies.google.com/privacy?hl=en-US"
            >Privacy Policy &ndash; Privacy &amp; Terms &ndash; Google</a
          >.. MixpanelのPrivacy Statement
          <a href="https://mixpanel.com/legal/privacy-policy"
            >https://mixpanel.com/legal/privacy-policy</a
          >からご確認ください。
        </p>
        <p>
          当社は匿名、統計、または集計情報を使用し、正当なビジネス目的で関連会社と共有します。当社またはその他の者が集計情報からデータを抽出し具体的に貴殿に関連付けることが合理的にできないため、プライバシーに何の影響がありません。
        </p>
        <h1 ref="your_choice">貴殿の選択</h1>
        <p>
          当社は、貴殿に関連する個人データの使用及び共有方法について選択肢を提供し、貴殿の選択を尊重します。
        </p>
        <p>
          ニュースレターやプロモーションメールをユーザーに送信します。これらの連絡を受け取らないようにするためには、メール内の「メール配信停止」リンクをクリックし、メールアドレスを確認する必要があります。
        </p>
        <p>
          当社は、本ポリシーに記載されている目的のために、貴殿に関連する個人データを収集し、受領します。貴殿はいつでもサービスの利用を停止することができ、その後、当社は貴殿に関連する個人データを収集しません。ただし、前述したように、当社は貴殿に関連する特定の個人データを保存し、引き続き使用または利用できるようにします。
        </p>
        <p>
          当社にご連絡を頂くことで、貴殿は当社のアカウントの停止と、貴殿に関連する個人データの削除を要求することができます。アカウントを停止すると、当社のライブデータベースに格納されている貴殿のアカウント情報や、サービス内に格納されているアカウントのすべての情報とデータが削除されます。当社が顧客の顧客に関連する個人データを処理する場合、当社の顧客と協力しながら削除依頼に対応します。
        </p>
        <p>
          当社にご連絡を頂くことで、当社が保管している貴殿に関する個人データのコピーを要求することができます。
        </p>
        <p>
          当社が貴殿から、または貴殿について収集した貴殿に関連する個人データを削除すると、そのデータは当社のアクティブなデータベースから削除されますが、当社は合理的な数のコピーをアーカイブに保管します。当社は貴殿のアカウントを無効化しますが、上記の正当なビジネス目的のために貴殿に関連する個人データを引き続き保持します。
        </p>
        <p>
          当社は、一部の人はいかなる形式であっても、自身に関連する個人データが処理されないことを希望する場合があることを理解しています。当社の写真撮影システムが自動化されているため、個人の肖像を撮影しないようにすることはできません。貴殿の写真は撮られたが、当社による保持を希望しない場合、当社のスタッフにお声がけを頂ければ、当画像をシステムから削除します。このように写真の削除をご希望される前であれば、当写真の物理的なプリントを購入することができます。画像が削除されると、その削除は永久的なものとなり、当社であっても画像を復元することはできません。
        </p>
        <p>
          キャプチャ後、貴殿の画像はクラウドプラットフォームにアップロードされ、そこで合成や画像調整などの初期処理が適用されます。サービスを利用するまで、それ以上の処理は行われません。画像は最大で90日間保持され、その後、自動的に削除されます。
        </p>
        <p>
          貴殿に関連する個人データにおける選択肢やオプトアウト権を含む権利の行使をご希望の場合、<a
            href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >までご連絡ください。
        </p>
        <h1 ref="eu_data">EUデータ主体の権利</h1>
        <p>
          <strong>当社による貴殿の個人データの処理が</strong><strong>EU</strong
          ><strong>のデータ保護法の対象の場合、次の条件が適用されます。</strong>
        </p>
        <p>
          貴殿がサービスを利用または訪問する際に、当社が貴殿に関連する個人データを処理する場合、当該データの処理は以下の法的根拠に基づきます。
        </p>
        <ul>
          <li>
            以下の法的根拠に基づかない貴殿に関連する個人データのすべての処理は、貴殿の同意に基づいています。
          </li>
          <li>
            当社は、法的義務を果たすため、または貴殿及びその他の者の重大な利益を保護するために貴殿に関連する個人データを処理します。
          </li>
          <li>
            また当社は、以下の目的のために、貴殿の基本的権利と自由に優越されていないと信じる当社の正当な利益に依存します。
            <ul>
              <li>
                次の場合における貴殿とのやり取り。
                <ul>
                  <li>
                    サービスやその他のデジタル資産を通じて貴殿からご連絡を頂くとき。
                  </li>
                  <li>
                    貴殿が当社のマーケティングニュースレターの登録をしたとき。
                  </li>
                  <li>
                    貴殿が、貴殿の会社を代表して、いずれのサービスの登録をしたとき。
                  </li>
                </ul>
              </li>
              <li>サイバーセキュリティ。</li>
              <li>サポート、顧客対応、サービス業務</li>
              <li>詐欺の検出及びサービスの不正利用。</li>
            </ul>
          </li>
        </ul>
        <p>
          本ポリシーの他のセクションに基づく権利に加えて、貴殿は以下の権利を有しています。
        </p>
        <ul>
          <li>
            当社に連絡し、貴殿に関連する個人データの処理に対する同意をいつでも撤回できる権利。なお、この権利を行使した場合、撤回前の同意に基づく処理の合法性に影響はありません。
          </li>
          <li>
            貴殿に関連する個人データを削除もしくは制限することを要求できる権利。当社は、自社の裁量と適用法の規定に基づき、貴殿のリクエストを検討し、結論を導きます。
          </li>
          <li>
            貴殿が上記の権利のいずれか（または複数）を行使する場合、適用法の規程に従い、貴殿は、本ポリシーに基づいて貴殿に関連する個人データを保有する第三者が適切に行動することについての通知を要求することができます。
          </li>
          <li>
            貴殿は、データポータビリティの権利に従って、貴殿に関連する個人データの転送を要求することができます。
          </li>
          <li>
            貴殿は、ダイレクトマーケティングのための貴殿に関連する個人データの処理に対して異議を唱えることができます。この権利に関する詳細は、このポリシーの「貴殿の選択」セクションでご覧頂けます。
          </li>
          <li>
            貴殿は、貴殿に関して法的効果をもたらす、または同様に重大な影響を及ぼす、プロファイリングを含む自動処理に基づく決定の対象とならない権利を有しています。
          </li>
          <li>
            GDPRの違反の疑いがある場合、貴殿は、常居所または勤務地を管轄するデータ保護監督当局に苦情を申し立てる権利を有しています。
          </li>
        </ul>
        <p>
          貴殿のEUデータ保護法に基づく権利のサマリ及び詳細な情報は下記の欧州委員会のウェブサイトからご覧頂けます：<a
            href="https://ec.europa.eu/info/law/law-topic/data-protection/reform/rights-citizens_en"
            >国民の権利 | 欧州委員会 (europa.eu)</a
          >。
        </p>
        <p>
          貴殿が権利を行使するためのリクエストを当社にお送り頂く際には、身元と所在地を合理的に認証できる必要があることにご留意ください。当社は、貴殿が本人であることを確認するために資格情報の提供を求め、さらに貴殿のリクエストの性質と範囲を理解するために質問をさせて頂くことがあります。
        </p>
        <p>
          貴殿のリクエストに基づき、貴殿に関連する個人データを削除する必要がある場合、当個人データのコピーをアクティブサーバー及びバックアップシステムから完全に削除するまでには時間がかかる場合があります。
        </p>
        <p>
          貴殿に関連する個人データの処理方法につき懸念事項がありましたら、当社のデータ保護責任者（<a
            href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >）までご連絡ください。頂いたお問い合わせを調査し、誠意を持って迅速に対応させて頂きます。
        </p>
        <p>
          <strong>データ保護責任者及び</strong><strong>EU</strong
          ><strong>並びに</strong><strong>UK</strong><strong>代表</strong>
        </p>
        <p>
          当社のデータ保護責任者のメールアドレスは<a
            href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >です。
        </p>
        <p>
          当社のEU代表の住所はC/Federico Mompou 5, Parque Empresarial Las
          Tablas, Edificio 1, Planta 3, 28050, Madrid,
          Spainで、メールアドレスは<a href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >です。
        </p>
        <p>
          当社のUK代表の住所は9 Victoria Way, Pride Park, Derby, United Kingdom
          DE24 8ANで、メールアドレスは<a href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >です。
        </p>
        <h1 ref="us_residents">米国向けの特定規定居住者</h1>
        <p>
          本セクションは、すべてのサービス訪問者、ユーザー、及びアメリカ合衆国（米国）に居住するその他の者にのみ適用されます。当社は、米国の州プライバシー法を遵守するためにこのセクションを採用しており、米国の州プライバシー法で定義されている用語は、このセクションにおいて同様の意味を持ちます。この章は、本ポリシーの他のセクションと矛盾する規定より優先されます。
        </p>
        <p>
          当社は、本ポリシーの「私たちが受領、収集、保管する個人データ」セクションに記載されている、貴殿に関連する個人データを収集しました。当情報は、以下のカテゴリーで構成されます。
        </p>
        <ul>
          <li>
            カリフォルニア州顧客記録法など、適用法に言及されている識別子および個人データのカテゴリー（Civ.Code
            &sect; 1798.80(e))。
          </li>
          <li>
            インターネットまたはその他の電子ネットワークアクティビティ情報。これには、閲覧履歴、検索履歴、サービスとのやり取りに関する情報が含まれますが、これらに限定されません。
          </li>
          <li>
            購入、入手、検討した製品やサービス、あるいはその他の購入や消費の履歴や傾向を含む商業情報。
          </li>
          <li>位置情報データ、すなわち貴殿の物理的な位置または移動情報。</li>
          <li>上記情報から立てられた推論。</li>
        </ul>
        <p>
          当社は、前段の貴殿に関連する個人データのカテゴリーを次の情報源のカテゴリーから取得します。
        </p>
        <ul>
          <li>直接及び間接的に貴殿自身や貴殿のサービスの利用状況。</li>
          <li>信頼できるサービスプロバイダーを含む第三者。</li>
        </ul>
        <p>
          当社は、本ポリシーに記載されている目的のために収集或いは受領する貴殿に関連する個人データを利用します。
        </p>
        <p>
          当社は、「誰と個人データを共有していますか？」のセクションで前述したように、事業目的で貴殿に関連する個人データを第三者に開示することがあります。
        </p>
        <p><strong>個人データの販売及び共有</strong></p>
        <p>
          当社は個人データを販売または共有しません。ただし、当社は分析、マーケティングオートメーション、ユーザー体験などのサービスを提供する第三者と連携し、彼らにサービス上で個人データを収集する権限を与えています。
        </p>
        <p>
          当社は、16歳未満の消費者の個人データを故意に販売または共有することはありません。
        </p>
        <p>
          過去12カ月間にこれらの第三者によって収集された個人データのカテゴリには、識別子、オンライン行動、及びその行動から立てられた推論が含まれます。
        </p>
        <p>
          これらの第三者は、前述した情報の収集に対して当社に一切の支払を行っていませんが、彼らに与えられた個人データの収集権は、クロスコンテキスト行動広告のための販売または共有を目的とした開示とみなされる可能性があります。ご連絡を頂ければ、貴殿はいつでも当社のサービスプロバイダーによる個人データの収集からオプトアウトすることができます。
        </p>
        <p><strong>米国居住者としての権利</strong></p>
        <p>
          貴殿に関連する個人データについて、本ポリシーの他のセクションに基づく権利に加え、貴殿がカリフォルニア州またはその他の該当する米国の州の居住者である場合、CPRAまたはその他の該当する米国の州消費者プライバシー法に基づく次の特定の権利を有します。
        </p>
        <ul>
          <li>
            特定の個人データへのアクセス及びデータポータビリティの権利 &ndash;
            貴殿は、過去12カ月間にわたる貴殿に関連する個人データの収集及び使用について、特定の情報を開示するよう当社に要求する権利を有します。貴殿のリクエストを確認したあと、以下を開示します。
            <ul>
              <li>当社が貴殿に関して収集した個人データのカテゴリー</li>
              <li>当社が貴殿に関して収集した個人データの情報源のカテゴリー</li>
              <li>当個人データを収集した際の当社の事業または商業目的</li>
              <li>
                当社が事業目的で開示した個人データのカテゴリー、及びその特定カテゴリーの個人データを開示した第三者のカテゴリー
              </li>
              <li>当社が貴殿に関して収集した特定の個人データ</li>
              <li>
                当社が事業目的で貴殿に関連する個人データを開示した場合、各カテゴリーの受領者が取得した個人データのカテゴリーを記載した一覧表を提供します。
              </li>
            </ul>
          </li>
          <li>
            削除権 -
            貴殿は、貴殿に関連する個人データを削除するように当社に要求する権利を有します。貴殿のリクエストを確認したあと、例外が適用される場合を除き、当社は貴殿に関連する個人データを当社の記録から削除します。
          </li>
          <li>
            差別の禁止 &ndash;
            貴殿は、CPRAに基づく権利の行使によって差別されない権利も有します。
          </li>
        </ul>
        <p><strong>権利の行使</strong></p>
        <p>
          前述したアクセス、データポータビリティ、または削除権を行使する場合、<a
            href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >までご連絡ください。貴殿または貴殿の代理人のみが貴殿に関連する個人データに関する要求を行うことができます。アクセスの要求は、12カ月以内に2回のみ行うことができます。
        </p>
        <p>
          検証可能な消費者要求は、当社が個人データを収集した対象者またはその正当な代理人であることを合理的に検証するために十分な情報を含めなければなりません。また、リクエストを適切に理解、評価、応答するために十分な詳細を含める必要があります。
        </p>
        <p>
          貴殿の身元、または貴殿に関連する個人データを要求する権利の有無を確認できない場合、貴殿のリクエストに対応したり、要求された個人データを提供したりすることができません。当社は、貴殿のリクエストに含まれる個人データを、貴殿の身元や当リクエストを行うための権限有無の確認のみに使用します。
        </p>
        <p>
          貴殿のリクエストには、受領後30日以内に対応できるよう最善を尽くします。それ以上の時間が必要な場合（最長30日）、その理由と延長期間を書面でお知らせします。貴殿が当社のアカウントをお持ちでない場合、貴殿の選択により、郵送または電子メールにて書面による回答をします。
        </p>
        <p>
          当社が開示する情報は、貴殿のリクエストを受領する前の12カ月間のもののみを対象とします。もし貴殿のリクエストに応じることができない場合、当社からの回答にはその理由も含まれます。
        </p>
        <p>
          当社は、過度、反復的、または明らかに根拠のないリクエストでない限り、貴殿のリクエストの処理または応答に料金を請求することはありません。リクエストを処理するには料金がかかるべきと当社が判断した場合、処理する前にその決定の理由を通知し、費用の見積もりを提示します。
        </p>
        <p>
          当社は、本ポリシーに基づく権利を行使するために貴殿にアカウントの作成を要求することはなく、また貴殿が米国のプライバシー法に基づく権利を行使した事実のみを根拠として、サービスの利用料を増加させたり、可用性を低下させたりすることはありません。
        </p>
        <p>
          当社からの回答を受け取った後、ご連絡いただくことで当社の決定に対して異議を申し立てることができます。当社は、貴殿の異議申し立てを審議し、受領後60日以内に回答と決定理由の説明を提供します。所轄の司法長官に苦情を提出できるリンクも（利用可能な場合）提供します。
        </p>
        <h1 ref="japanese_data">日本のデータ保護法に基づく特定規程</h1>
        <p>
          当社は、個人情報の保護に関する法律（「<strong>APPI</strong>」）をはじめとする日本のプライバシー法（該当する場合）を遵守するためにこのセクションを採用しました。この章は、APPIが当社による貴殿に関連する個人データの処理に適用される場合のみに適用され、かつ本ポリシーの他のセクションと矛盾する規程より優先されます。
        </p>
        <p>
          貴殿に関連する個人データの種類、当社がそのような個人データを処理する目的、及び当社が個人データを共有する第三者に関する情報は、このポリシーに詳しく記載されています。
        </p>
        <p>
          貴殿は、本ポリシー内の他のセクションに基づく権利に加え、APPI
          またはその他の適用される日本のプライバシー法に基づく次の特定権利を有します。
        </p>
        <p>
          貴殿は、当社のサービス提供、保護及び改善、並びに適用法令の遵守に必要な範囲を超えて貴殿に関連する個人データの処理が行われている場合、当該個人データの削除または処理の停止を要求する権利を有します。&nbsp;
        </p>
        <p>
          貴殿は、貴殿に関連する個人データへのアクセス、当社の当該データにかかわるデータセキュリティ対策の概要、及び貴殿に関連する個人データをアクセスできる第三者並びにその領域を記載したリストの提供を要求する権利を有します。&nbsp;
        </p>
        <p>
          プライバシー権を行使する場合、<a href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >までご連絡ください。貴殿または貴殿の代理人のみが貴殿に関連する個人データに関するリクエストを行うことができます。&nbsp;貴殿は、貴殿が個人データを収集した対象者またはその正当な代理人であることを合理的に検証するために十分な情報を提供しなければなりません。また、リクエストを適切に理解、評価、応答するために十分な詳細を含める必要があります。
        </p>
        <p>
          個人データの利用管理を担当する組織は：&nbsp;<u>Pomvom Ltd.</u
          >で、個人データの利用管理を担当する者は：&nbsp;<u>Pomvom</u
          ><u>のデータ保護責任者</u>です。住所は：&nbsp;<u
            >9 Victoria Way, Pride Park, Derby, United Kingdom DE24 8AN</u
          >で、メールアドレスは<a href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >です。
        </p>
        <h1 ref="personal_data_retention">個人データ保持</h1>
        <p>
          当社は、情報処理の目的、当社の正当な事業目的、また適用法に基づく法的要件に応じて、貴殿に関連する様々な種類の個人データを異なる期間で保持します。
        </p>
        <p>
          連絡が取れるよう、貴殿の連絡先情報を保持します。<a
            href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >までご連絡を頂ければ、貴殿はいつでも当社のデータ保護責任者に連絡先情報の削除を依頼することができます。当社は、法的要件や手続きのために必要な場合、必要な期間で、貴殿の情報を使用せずに保管する場合があることをご了承ください。
        </p>
        <p>
          当社のサービス利用を終了した後も、貴殿に関連する個人データを保持します。ただし、保持は合理的に必要な範囲で行われ、ユーザー間の紛争の解決、詐欺や悪用の防止、または本ポリシー及び<a
            href="https://www.pomvom.com/terms"
            >利用規約</a
          >の執行に必要な場合に限ります。当社は、非識別化された集計情報を制約なく保持します。情報の処理が不要になった場合、当社は合理的な範囲で、識別可能な情報を削除または非識別化します。
        </p>
        <p>
          いかなる場合でも、適用法により削除が義務付けられている場合や、当社の裁量に基づき削除を決定した場合を除き、当社のサービスを利用している限り、本ポリシー及び当社の<a
            href="https://www.pomvom.com/terms"
            >利用規約</a
          >に従って貴殿に関連する情報を保持します。
        </p>
        <h1 ref="data_transfer">区域外のデータ転送</h1>
        <p>
          当社は、個人データを含む情報を、直接またはデータホスティングサービスプロバイダーといった第三者を通じて、イスラエル、日本、米国、EU内で保存及び処理します。貴殿のデータが保存及び処理される地域の法律は、お客様が居住する管轄区域の法律と異なる場合があります。
        </p>
        <p>
          貴殿が、ご自身に関連する個人データを別の地域に転送する場合に同意が必要な地域の居住者である場合、貴殿は、かかる転送につき明示的かつ明確な同意を当社に提供するものとします。
        </p>
        <p>
          貴殿が欧州経済領域（EEA）にお住まいの場合、当社は貴殿に関連する個人データを、適切な水準のデータ保護を提供していない他の地域に転送する場合があることをご了承ください。そのような場合には、関連する受取人と適宜、随時改正される欧州連合（EU）標準契約条項を締結することにより、適切な保護措置を講じます。また、同様のデータ転送規制に従うことにより、当該個人データのセキュリティと機密性を保護します。前述した個人データを転送する際に当社が使用する適切な保護措置のコピーを入手したり、データ転送に関する詳細な情報を得たりするには、<a
            href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >までご連絡ください。
        </p>
        <p>
          当社は、第三者のサービスプロバイダーに対して適切な機密保持及びセキュリティの取り組みを求め、貴殿に関連する個人データが本ポリシーに従って安全かつ適切に取り扱われることを保証するために合理的に必要なすべての措置を講じます。
        </p>
        <h1 ref="information_security">情報セキュリティー</h1>
        <p>
          当社は、個人データの安全性の確保に努めています。当社と当社のホスティングサービスは、貴殿に関連する個人データを保護するためのシステム、アプリケーション、手順を導入し、情報の盗難、損傷、損失、または情報の不正アクセスや使用のリスクを最小限に抑えます。これらの措置は、業界標準の堅固なセキュリティを実現します。
        </p>
        <p>
          ただし、突破できないセキュリティシステムはなく、当社は貴殿のプライバシーを保護するよう努めておりますが、サービスが不正行為、機能不全、違法な傍受やアクセス、その他の悪用や悪用から免れることの保証ができないことをご理解ください。
        </p>
        <p>
          当社サービスの技術的な基盤がどのように機能し、適用される法律に従っていかにプライバシーを保護しているかに関する詳細な情報については、<a
            href="https://pomvom.com/faq"
            >「技術とプライバシーに関するよくある質問（FAQ）」をご確認ください</a
          >。
        </p>
        <h1 ref="privacy_updates">プライバシーポリシーの更新</h1>
        <p>当社は定期的に本ポリシーを更新します。</p>
        <p>
          更新による影響が軽微の場合、当更新はサービスに通知を投稿してから7日後に有効になります。更新による影響が重大の場合、当更新は最初に通知を投稿してから30日後に有効になります。
        </p>
        <p>
          新しいポリシーの効力が発生するまで、当ポリシーがその時点の既存ポリシーと比較して貴殿の基づくプライバシー権利の保護を大幅に低下させる場合、そのポリシーを受け入れず、サービス利用の終了を選択できます。
        </p>
        <p>
          新しいポリシーの効力発生後にサービスのご利用を継続することは新しいポリシーに同意したこととなります。
        </p>
        <p>
          法律要件に合わせてポリシーを更新する必要がある場合、新しいポリシーは即座にまたは法律で定められた期間に従って効力を発生することにご留意ください。
        </p>
        <h1 ref="contact_us">お問い合わせ</h1>
        <p>
          お問い合わせは<a href="mailto:privacy@pomvom.com"
            >privacy@pomvom.com</a
          >までお願いします。
        </p>
        <p>
          貴殿のリクエストを処理するために十分な情報が添えられたリクエストのみ処理することができます。貴殿のリクエストを処理するために追加情報が必要な場合はご連絡させて頂くことがあります。最初に十分な情報を提供せず、そして当社による追加情報のリクエストに応じない場合、当社は貴殿のリクエストを処理することができません。
        </p>
        <p>
          電子メールは常に安全であるとは限らないため、当社への電子メールには機密情報を含めないようにお願いします。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSelector from './LanguageSelector'

export default {
  name: "PrivacyPolicy",
  components: {
    LanguageSelector
  },
  data() {
    return {};
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(() => {
        document.querySelector("h3" + this.$route.hash).scrollIntoView();
      }, 1000);
    }
  },
  methods: {
    scrollToRef(refName) {
      this.$refs[refName].scrollIntoView();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
table {
  border-collapse: collapse;
}

table,
th,
td {
  vertical-align: top;
}

tr {
  border-bottom: 1pt solid black;
}

tr:last-child {
  border-bottom: none;
}

td {
  padding-left: 2px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.region-heading {
  font-size: 2.5em;
  font-weight: normal;
  text-align: center;
  margin-bottom: 0.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue